import { useEffect, useState } from "react";
import { api } from "@/lib/api";

let cache = null; const subs = new Set();
export const DEFAULT_PREFS = { display: { home: "/", period: "month", scope: "auto", density: "standard" }, data: { compare: "prev" }, shortcuts: [], columns: {}, dashboard: {} };

/* Préférences compte (chargées une fois, partagées entre composants). */
export function usePrefs() {
  const [p, setP] = useState(cache || DEFAULT_PREFS);
  useEffect(() => {
    subs.add(setP);
    if (!cache) api.get("/profile/preferences").then(r => { cache = r.data.prefs; subs.forEach(f => f(cache)); }).catch(() => {});
    return () => subs.delete(setP);
  }, []);
  return p;
}
export function invalidatePrefs() { cache = null; }
